import React from 'react';
import PropTypes from 'prop-types';

import { Image } from '$partials/media';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleSingleImage = ({
    image = {},
    video = {},
    caption,
    layout = 'Trunk',
    nextTypename
}) => {
    if (layout === 'Wide') {
        if (video) {
            return (
                <figure className='my-44 md:my-70 px-10 sm:px-20'>
                    <video
                        autoPlay={true}
                        className='w-full h-full object-cover aspect-[16/9]'
                        controls={false}
                        loop='loop'
                        muted={true}
                        playsInline={true}
                        src={video?.src} />
                    {!!caption &&
                        <figcaption className={`${nextTypename === 'ModuleText' && 'md:absolute '}w-full sm:w-4/6 md:w-4/12 type-style-7 text-dark-grey whitespace-pre-wrap mt-5 sm:mt-15`}>
                            {caption}
                        </figcaption>
                    }
                </figure>
            );
        } else {
            return (
                <figure className='my-44 md:my-70 px-10 sm:px-20'>
                    <Image
                        loadWidth={1200}
                        {...image} />
                    {!!caption &&
                        <figcaption className={`${nextTypename === 'ModuleText' && 'md:absolute '}w-full sm:w-4/6 md:w-4/12 type-style-7 text-dark-grey whitespace-pre-wrap mt-5 sm:mt-15`}>
                            {caption}
                        </figcaption>
                    }
                </figure>
            );
        }
    } else {
        if (video) {
            return (
                <figure className='w-full flex flex-wrap my-30 md:my-60 md:flex-row-reverse'>
                    <div className='w-full md:w-10/12 px-10 sm:px-20'>
                        <video
                            autoPlay={true}
                            className='w-full h-full object-cover aspect-[16/9]'
                            controls={false}
                            loop='loop'
                            muted={true}
                            playsInline={true}
                            src={video?.src} />
                    </div>
                    {!!caption &&
                        <figcaption className='w-full sm:w-4/6 md:w-2/12 type-style-7 text-dark-grey whitespace-pre-wrap mt-5 sm:mt-10 md:mt-0 px-10 sm:px-20'>
                            {caption}
                        </figcaption>
                    }
                </figure>
            );
        } else {
            return (
                <figure className='w-full flex flex-wrap my-30 md:my-60 md:flex-row-reverse'>
                    <div className='w-full md:w-10/12 px-10 sm:px-20'>
                        <Image
                            loadWidth={1162}
                            {...image} />
                    </div>
                    {!!caption &&
                        <figcaption className='w-full sm:w-4/6 md:w-2/12 type-style-7 text-dark-grey whitespace-pre-wrap mt-5 sm:mt-10 md:mt-0 px-10 sm:px-20'>
                            {caption}
                        </figcaption>
                    }
                </figure>
            );
        }
    }
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

ModuleSingleImage.propTypes = {
    caption: PropTypes.string,
    image: PropTypes.shape({
        src: PropTypes.string.isRequired
    }).isRequired,
    layout: PropTypes.string,
    video: PropTypes.object,
    nextTypename: PropTypes.string,
};

export default ModuleSingleImage;
